import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { AppState } from 'redusers/config'

export const useIsCollapseMenu = () => {
  return useSelector((state: AppState) => state.collapseMenuReducer.isCollapseMenu)
}
